import React from 'react';
import { PostEditorContextType, PostEditorTypeUndefined } from '../../providers/AppProvider';
import { PostEditorNew } from './PostEditorNew';
import { PostEditorContextEnum } from '../../models/post-editor';
import { PostEditorEdit } from './PostEditorEdit';
import { PostEditorBulkImport } from './PostEditorBulkImport';
import { useDidMount } from '../../hooks/useDidMount';
import { useApolloClient } from '@apollo/client';
import { PostEditorNewFromPost } from './PostEditorNewFromPost';

export type PostEditorViewProps = {
  //
  context: Exclude<PostEditorContextType, PostEditorTypeUndefined>;
};

export const PostEditorView = ({ context }: PostEditorViewProps): JSX.Element => {
  const { cache: apolloCache } = useApolloClient();
  // if we close post editor we want to remove any existing cached links metadata
  useDidMount(() => () => {
    // we get all serialized cached data
    const serializedState = apolloCache.extract();
    // we check all cached objects and search for LinkMetadata, and remove it
    for (const [key, value] of Object.entries(serializedState)) {
      if (value.__typename === 'LinkMetadata') {
        apolloCache.evict({ id: key });
      }
    }
    apolloCache.gc();
  });

  switch (context.type) {
    case PostEditorContextEnum.new:
      return <PostEditorNew />;
    case PostEditorContextEnum.duplicate:
    case PostEditorContextEnum.reschedule_new:
      return <PostEditorNewFromPost postId={context.postId} />;
    case PostEditorContextEnum.edit:
    case PostEditorContextEnum.reschedule_edit:
    case PostEditorContextEnum.restore_trashed:
      return <PostEditorEdit postId={context.postId} />;
    case PostEditorContextEnum.import:
      return <PostEditorBulkImport />;
    default:
      return <></>;
  }
};
